import React, {useState} from "react";
import {
    EuiButton, EuiButtonEmpty, EuiFieldNumber, EuiFieldText,
    EuiModal, EuiModalBody, EuiModalFooter, EuiModalHeader, EuiModalHeaderTitle, EuiProgress, EuiSpacer,
    EuiTable,
    EuiTableHeader,
    EuiTableHeaderCell,
    EuiTableRow,
    EuiTableRowCell
} from "@elastic/eui";


interface User {
    userStatus: string;
    userId: number;
    profileName: string;
    distributorName: string;
    credits: number;
    pendingPayments: number;
}
interface SellerTableChild {
    onSellerChildChange: () => void;
    batches: User[]
}

export  const SellerTable: React.FC<SellerTableChild> = ({ onSellerChildChange , batches }) => {
    const [banUserId,setBanUserId] = useState<number>();
    const [banModal,setBanModal] = useState(false)
    const [transferUserId,setTransferUserId] = useState<number>();
    const [transferModal,setTransferModal] = useState(false)
    const [loadingTransferCredit,setLoadingTransferCredit] = useState(false)
    const [numberOfPin, setNumberOfPin] = useState(0);

    const [approveUserId,setApproveUserId] = useState<number>();
    const [approveModal,setApproveModal] = useState(false)
    const [loadingApprove,setLoadingApprove] = useState(false)
    const [payment, setPayment] = useState(0);


    const onNChange = (n:any) => {
        setNumberOfPin(n.target.value);
    };
    const onPChange = (n:any) => {
        setPayment(n.target.value);
    };

    let approveMod;

    async function approvingPayment() {
        setLoadingApprove(true)

        try {
            const token = localStorage.getItem('token');
            const response = await fetch('/api/v1/payment/aprove', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({sellerId: approveUserId, amount: payment}),
            });
            const data = await response.json();
            alert(data.status)
            onSellerChildChange();
            setLoadingApprove(false)

        } catch (error) {
            console.error('Error  approving payment:', error);
            setLoadingApprove(false);
        }

    }

    if(approveModal){
        let filteredArray = batches.filter((obj)=> obj.userId == approveUserId);
        approveMod = (<EuiModal onClose={() => setApproveModal(false)}>

            <EuiModalHeader>
                <EuiModalHeaderTitle>Approve payment</EuiModalHeaderTitle>
            </EuiModalHeader>
            {loadingApprove ? (
                <EuiProgress size="xs" color="accent" />):(
                <EuiModalBody>

                    <EuiModalHeader>User Name : {filteredArray[0].profileName}</EuiModalHeader>

                    <EuiSpacer />
                    <EuiFieldNumber
                        placeholder="Enter credit amount payed"
                        value={payment}
                        onChange={(n) => onPChange(n)}
                    />

                </EuiModalBody>)}
            <EuiModalFooter>
                <EuiButtonEmpty onClick={() => setApproveModal(false)}>Cancel</EuiButtonEmpty>
                <EuiButton onClick={approvingPayment} fill>
                    Confirm
                </EuiButton>
            </EuiModalFooter>
        </EuiModal>)
    }
    function ApprovePayment(userId: number) {
        setApproveUserId(userId)
        setApproveModal(true)
    }


    async function transferingCredit() {
        setLoadingTransferCredit(true)

        try {
            const token = localStorage.getItem('token');
            const response = await fetch('/api/v1/credit/transfercredit', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({userId: transferUserId ,transferAmount: numberOfPin}),
            });
            const data = await response.json();
            alert(data.status)
            onSellerChildChange();
            setLoadingTransferCredit(false)
            setLoadingTransferCredit(false)
        } catch (error) {
            console.error('Error Transfering credit:', error);
            setLoadingTransferCredit(false);
        }


    }

    let transferCreditModal;
    function transferCredit(batchId: any) {
        setTransferUserId(batchId)
        setTransferModal(true)
    }
    if(transferModal){
        let filteredArray = batches.filter((obj)=> obj.userId == transferUserId);
        console.log(filteredArray)
        transferCreditModal = (<EuiModal onClose={() => setTransferModal(false)}>

            <EuiModalHeader>
                <EuiModalHeaderTitle>Transfer Credit</EuiModalHeaderTitle>
            </EuiModalHeader>
            {loadingTransferCredit ? (
                <EuiProgress size="xs" color="accent" />):(
                <EuiModalBody>

                   <EuiModalHeader>User Name : {filteredArray[0].profileName}</EuiModalHeader>

                    <EuiSpacer />
                    <EuiFieldNumber
                        placeholder="Enter the Number of Credit"
                        value={numberOfPin}
                        onChange={(n) => onNChange(n)}
                    />

                </EuiModalBody>)}
            <EuiModalFooter>
                <EuiButtonEmpty onClick={() => setTransferModal(false)}>Cancel</EuiButtonEmpty>
                <EuiButton onClick={transferingCredit} fill>
                    Transfer
                </EuiButton>
            </EuiModalFooter>
        </EuiModal>)

    }

    let banUserModal;

    function BanUser(userId: any) {
        setBanUserId(userId)
        setBanModal(true)
    }

     async function changeStatusOfUser() {
        const token = localStorage.getItem('token');
        const response = await fetch('/api/v1/prof/banuser', {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ user: banUserId }),
        });
        const data = await response.json();
        alert(data.message)
        onSellerChildChange();
        setBanModal(false)


    }

    if(banModal){

        let filteredArray = batches.filter((obj)=> obj.userId == banUserId);
        console.log(filteredArray)
            let stat;
            if(filteredArray[0].userStatus == "ACTIVE"){
                stat ="BANNED"
            }else {
                stat = "ACTIVE"
            }

        banUserModal = ( <EuiModal onClose={() => setBanModal(false)}>
                <EuiModalHeader>
                    <EuiModalHeaderTitle>Change the status of batch</EuiModalHeaderTitle>
                </EuiModalHeader>
                <EuiModalBody>
                      {filteredArray[0].profileName} status will be changed from {filteredArray[0].userStatus} to {stat}
                </EuiModalBody>
                <EuiModalFooter>
                    <EuiButtonEmpty onClick={() => setBanModal(false)}>Cancel</EuiButtonEmpty>
                    <EuiButton onClick={changeStatusOfUser} fill>
                        Confirm
                    </EuiButton>
                </EuiModalFooter>
            </EuiModal>)

    }



    return( <EuiTable>
        <EuiTableHeader>
            <EuiTableHeaderCell>User ID</EuiTableHeaderCell>
            <EuiTableHeaderCell>User Name</EuiTableHeaderCell>

            <EuiTableHeaderCell>Credits</EuiTableHeaderCell>
            <EuiTableHeaderCell>Pending Payments</EuiTableHeaderCell>
            <EuiTableHeaderCell>User Status</EuiTableHeaderCell>
            <EuiTableHeaderCell>Transfer</EuiTableHeaderCell>
            <EuiTableHeaderCell>Ban</EuiTableHeaderCell>
            <EuiTableHeaderCell>Approve Payment</EuiTableHeaderCell>
        </EuiTableHeader>

        {batches.map((batch) => (
            <EuiTableRow key={batch.userId}>
                <EuiTableRowCell>{batch.userId}</EuiTableRowCell>
                <EuiTableRowCell>{batch.profileName}</EuiTableRowCell>

                <EuiTableRowCell>{batch.credits}</EuiTableRowCell>
                <EuiTableRowCell>{batch.pendingPayments}</EuiTableRowCell>
                <EuiTableRowCell>
                <span style={{ color: batch.userStatus === 'ACTIVE' ? 'green' : 'red' }}>
                {batch.userStatus}
                </span></EuiTableRowCell>

                <EuiTableRowCell>
                    <EuiButton size="s" onClick={() => transferCredit(batch.userId)}>
                        Transfer Credit
                    </EuiButton>
                </EuiTableRowCell>
                <EuiTableRowCell>
                    <EuiButton size="s" onClick={() => BanUser(batch.userId)}>
                        Change
                    </EuiButton>
                </EuiTableRowCell>
                <EuiTableRowCell>
                    <EuiButton size="s" onClick={() => ApprovePayment(batch.userId)}>
                      Approve
                    </EuiButton>
                </EuiTableRowCell>
            </EuiTableRow>
        ))}

        {banUserModal}
        {transferCreditModal}
        {approveMod}

    </EuiTable>)
}